'use client';

import { browserApiRequest } from '@/shared/api';

import { OrderSchema, PlaceOrderResultSchema, type PlaceOrderCommand } from '../model/order';

/** One key per checkout attempt: a retried request returns the same order instead of a duplicate. */
export function placeOrder(command: PlaceOrderCommand, idempotencyKey: string) {
  return browserApiRequest('/api/checkout', PlaceOrderResultSchema, {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: JSON.stringify(command),
  });
}

/** Demo stand-in for the CloudPayments widget result (see docs/MOCKING.md). */
export function submitMockPayment(orderId: string, outcome: 'success' | 'fail') {
  return browserApiRequest(`/api/payments/mock/${encodeURIComponent(orderId)}`, OrderSchema, {
    method: 'POST',
    body: JSON.stringify({ outcome }),
  });
}
